import React from 'react';
import qs from 'qs';
import styled from 'styled-components';
const UnsplashLink = styled.a `
    color: ${(props) => props.theme.colors.primary};
`;
export const UNSPLASH_TRACKING_TAGS = {
    utm_source: 'adept',
    utm_medium: 'referral'
};
const queryParams = qs.stringify(UNSPLASH_TRACKING_TAGS);
const UnsplashCredit = ({ profile, photographer }) => {
    if (profile && photographer) {
        return (React.createElement("p", null,
            "Photo by",
            ' ',
            React.createElement(UnsplashLink, { href: `${profile}?${queryParams}`, target: "_blank", rel: "noreferrer noopener" }, photographer),
            ' ',
            "on",
            ' ',
            React.createElement(UnsplashLink, { href: `https://unsplash.com?${queryParams}`, target: "_blank", rel: "noreferrer noopener" }, "Unsplash")));
    }
    return null;
};
export default UnsplashCredit;
//# sourceMappingURL=index.js.map